import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router";
import { GlobalContext } from "../Context/GlobalContext";
import { Link, useLocation } from "react-router-dom";
import Menu from "../images/mobile-menu.svg";
import Profile from "../images/mobile-profile.svg";
import X from "../images/x.svg";

// ...

const MobileHeader: React.FC = () => {
  const [menuDropDownData, setMenuDropDownData] = useState({
    content: [
      { href: "/dashboard", text: "Dashboard" },
      { href: "/about", text: "About Us", hasNested: true },
      { href: "/about", text: "Our Team", isNested: true },
      { href: "/faq", text: "FAQ", isNested: true },
      { href: "/contact", text: "Contact Us", isNested: true },
      { href: "/browse", text: "Browse Dogs" },
      { href: "/get-involved", text: "Get Involved" },
      { href: "/donate", text: "Donate" },
      { href: "/shop", text: "Shop" },
      { href: "/community-partners", text: "Community Partners" },
      { href: "/privacy-policy", text: "Privacy Policy" },
      { href: "/terms", text: "Terms of Service" },
    ],
    expanded: false,
  });
  const [communityPartnerStatus, setCommunityPartnerStatus] =
    useState("NotLogged");
  const navigate = useNavigate();
  const location = useLocation();
  const context = useContext(GlobalContext);

  const authorized = context?.authorized;
  const setAuthorized = context?.setAuthorized ?? (() => {});

  const handleCommunityPartnerClick = () => {
    if (communityPartnerStatus === "NotLogged") {
      navigate("/login/");
      setMenuDropDownData((prevData) => ({
        ...prevData,
        expanded: false,
      }));
      return;
    }
    if (communityPartnerStatus === "Logged") {
      navigate("/dashboard");
      setMenuDropDownData((prevData) => ({
        ...prevData,
        expanded: false,
      }));
      return;
    }
  };

  useEffect(() => {
    if (authorized) {
      setCommunityPartnerStatus("Logged");
    } else {
      setCommunityPartnerStatus("NotLogged");
    }
  }, [authorized, location.pathname]);

  const toggleMenu = () => {
    setMenuDropDownData((prevData) => ({
      ...prevData,
      expanded: !prevData.expanded,
    }));
  };

  const handleLogoClick = () => {
    navigate("/");
    setMenuDropDownData((prevData) => ({
      ...prevData,
      expanded: false,
    }));
  };

  return (
    <header className="flex w-full flex-col font-poppins text-gray-dark">
      <section className="flex w-full flex-row justify-between px-6 py-2">
        <div className="justify-left flex w-[55px] items-center">
          <button
            onClick={toggleMenu}
            className="flex items-center justify-center"
          >
            <img src={menuDropDownData.expanded ? X : Menu} alt="Menu" />
          </button>
        </div>
        <div className="flex h-[55px] w-[170px] items-center justify-center">
          <div className="flex flex-1 items-center justify-center">
            <button
              className="flex max-w-363 items-center justify-center"
              onClick={() => handleLogoClick()}
            >
              <img
                src="/images/png-jpg/pup_profile_header.png"
                alt="Pup Profile Header Logo"
              />
            </button>
          </div>
        </div>
        <div className="flex flex-col items-center gap-1">
          <div className="flex flex-row gap-1">
            <button
              onClick={() => {
                navigate("/donate");
                window.scrollTo(0, 0);
              }}
              className="flex items-center justify-center rounded-md bg-yellow px-3 py-1 transition hover:bg-yellow/90"
            >
              <p className="font-poppins text-xs font-bold text-white">
                Donate
              </p>
            </button>
            <button
              onClick={() => {
                navigate("/shop");
                window.scrollTo(0, 0);
              }}
              className="flex items-center justify-center rounded-md bg-blue px-3 py-1 transition hover:bg-blue-dark"
            >
              <p className="font-poppins text-xs font-bold text-white">
                Shop
              </p>
            </button>
          </div>
          {authorized && (
            <button
              onClick={handleCommunityPartnerClick}
              className="flex items-center justify-center"
            >
              <img src={Profile} alt="Profile"></img>
            </button>
          )}
        </div>
      </section>
      <line className="h-[2px] w-full bg-blue"></line>
      <section>
        {menuDropDownData.expanded &&
          menuDropDownData.content
            .filter((item) => authorized || item.text !== "Dashboard")
            .map((item, index) => (
              <div className="flex flex-col" key={index}>
                <Link
                  to={item.href}
                  onClick={() =>
                    setMenuDropDownData((prevData) => ({
                      ...prevData,
                      expanded: false,
                    }))
                  }
                >
                  <div className={`py-3 font-semibold ${item.isNested ? 'ml-16 text-sm' : 'ml-12'}`}>{item.text}</div>
                </Link>
                <line className="h-[1px] w-full bg-gray"></line>
              </div>
            ))}
      </section>
    </header>
  );
};

export default MobileHeader;
